import db from "../db/database";
import { PaymentForm } from "../interfaces/payment-form";

const indexDB = db as any;

class FormaDePagoService {
  async getAll(): Promise<PaymentForm[]> {
    return await indexDB.formasPago.toArray();
  }

  // Alias de getAll() para mantener compatibilidad con componentes existentes
  async getAllFormasDePago(): Promise<PaymentForm[]> {
    return await this.getAll();
  }

  async getById(id: number): Promise<PaymentForm> {
    return await indexDB.formasPago.get(id);
  }

  async getByCode(code: string): Promise<PaymentForm> {
    return await indexDB.formasPago.where("Code").equals(code).first();
  }
}

const formaDePagoService = new FormaDePagoService();
export default formaDePagoService;
